import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function PublicRoutes({children}) {
  const isLogged = useSelector((state) => state.global.login);
  return (!isLogged)
  ? children
  : <Navigate to="/dashboard" />
}
